import { applyComponentTheme } from '../../../../theme';
import { NavItemMobileLink } from './styles';

export default applyComponentTheme(NavItemMobileLink, 'NavItemMobile');
